import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Help } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { Tooltip } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const styles = (theme) => ({
  root: {
    display: 'inline',
  },
  button: {
    width: theme.spacing(0),
    height: theme.spacing(0),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  icon: {
    color: theme.palette.facet.primaryGray,
    fontSize: theme.spacing(2),
  },
  tooltip: {
    backgroundColor: theme.palette.facet.darkGray,
  },
});

const HelperText = ({
  className,
  iconClassName,
  classes,
  text,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <Tooltip
        classes={{
          tooltip: classes.tooltip,
        }}
        title={text}
      >
        <IconButton className={classNames(classes.button, iconClassName)}>
          <Help className={classes.icon} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

HelperText.defaultProps = {
  className: '',
  iconClassName: '',
};

HelperText.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
};

export default withStyles(styles)(HelperText);
